export default __webpack_public_path__ + "static/media/hlb-color.f1ff123a.svg";